// Helpers over the search registry from GET /api/search/registry/: every
// page, setting and quick action the user may open (filtered on the server).

// Quick-action routes carry `?action=<key>` (or `&action=`). The page that
// receives it opens the matching form (useQuickActionFromUrl).
export const QUICK_ACTION_PARAM = "action";
export const QUICK_ACTIONS_BEFORE_TYPING = 4;

// The registry's `module` ("myworkspace", "payroll", ...) for the product on
// screen ("My Workspace", "Payroll", ...).
export const moduleKey = (productName) => String(productName || "").toLowerCase().replace(/[^a-z0-9]/g, "");

// Up to 4 quick actions for the module on screen, in `quick_order`.
export const quickActionsFor = (items, productName) => {
  const module = moduleKey(productName);
  return (items || [])
    .filter((item) => item.type === "action" && moduleKey(item.module) === module)
    .sort((a, b) => (a.quick_order ?? 99) - (b.quick_order ?? 99))
    .slice(0, QUICK_ACTIONS_BEFORE_TYPING);
};

const sortedQuery = (search) => {
  const params = new URLSearchParams(search || "");
  params.sort();
  return params.toString();
};

// The registry entry for the URL on screen, so opening a page from the
// sidebar or a direct link also goes to Recent. Query-string pages
// (Approvals ?view=leave, Payroll settings ?item=pf) must match their query
// too; a page without one matches on the path alone.
export const findEntryForLocation = (items, pathname, search) => {
  const query = sortedQuery(search);
  let pathOnly = null;
  for (const item of items || []) {
    const [itemPath, itemSearch = ""] = String(item.route || "").split("?");
    if (itemPath !== pathname) continue;
    if (itemSearch && sortedQuery(itemSearch) === query) return item;
    if (!itemSearch && !pathOnly && item.type !== "action") pathOnly = item;
  }
  return pathOnly;
};

// Employee results open the employee's side panel on People > Employee
// (?employee=<user id>), not the older full-page Edit Employee screen the
// API's route points to. The id comes from that route (or "employee:<id>").
export const EMPLOYEE_PARAM = "employee";
export const employeePanelRoute = (entry) => {
  const id =
    /\/hrzone\/edit\/employees\/([^/?#]+)/.exec(entry?.route || "")?.[1] ||
    /^employee:(.+)$/.exec(entry?.id || "")?.[1];
  return id ? `${EMPLOYEE_PAGE_PATH}?${EMPLOYEE_PARAM}=${encodeURIComponent(id)}` : entry?.route;
};

// Employee results open on People > Employee, so they are only shown when
// the registry (pages this user may open) has that page. Otherwise a click
// would land on a no-access screen.
export const EMPLOYEE_PAGE_PATH = "/admin/hrzone/employees";
export const canOpenEmployeePanel = (items) =>
  (items || []).some((item) => item.type === "page" && String(item.route || "").split("?")[0] === EMPLOYEE_PAGE_PATH);
